import { render, staticRenderFns } from "./tabelaDadosAcademicos.vue?vue&type=template&id=1d7d7c2c&"
import script from "./tabelaDadosAcademicos.vue?vue&type=script&lang=js&"
export * from "./tabelaDadosAcademicos.vue?vue&type=script&lang=js&"
import style0 from "./tabelaDadosAcademicos.vue?vue&type=style&index=0&id=1d7d7c2c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports